var sf = require("sprintf");

angular.
    module("sprintf", []).
    filter("sprintf", function() {
        return function() {
            return sf.sprintf.apply(null, arguments)
        }
    }).
    filter("fmt", ["$filter", function($filter) {
        return $filter("sprintf")
    }]).
    filter("vsprintf", function() {
        return function(format, argv) {
            return sf.vsprintf(format, argv)
        }
    }).
    filter("vfmt", ["$filter", function($filter) {
        return $filter("vsprintf")
    }])



/*****************
 ** WEBPACK FOOTER
 ** ./src/scripts/modules/sprintf.js
 ** module id = 367
 ** module chunks = 1
 **/